import { useMemo, useState, useRef, useEffect } from "react";
import _ from "lodash";

import ProcessDesignerFlowChartItem from "./ProcessDesignerFlowChartItem";
import ProcessDesignerFlowChartGroup from "./ProcessDesignerFlowChartGroup";
import ProcessDesignerFlowChartEntry from "./ProcessDesignerFlowChartEntry";
import { FindOpenPosition } from "../../tools/DesignerHelper";

import { getLabel } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
//MdArrowDropUp



const ProcessDesignerFlowchart = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const CurrentGroup = props.CurrentGroup;
  const AllGroup = props.Group;
  const Group = useMemo(() => {


    return AllGroup.filter(g => g.parentGroup == CurrentGroup[CurrentGroup.length - 1]._id)

  }, [AllGroup, CurrentGroup]);
  const AllStep = props.Step;
  const Step = useMemo(() => {
    return AllStep.filter(s => s.parentGroup == CurrentGroup[CurrentGroup.length -1]._id).map(s => {
      if (s.condition.length <= 0) return s;
      else{


        let condition = s.condition.map(c => {

          let tempStep = AllStep.find(pStep => pStep._id == c.processStep);

          let tempGroup = AllGroup.find(g => g._id == tempStep.parentGroup);

          return {
            ...c,
            position: tempStep.position,
            parentGroup: tempGroup,
            useGroupPosition: tempGroup && tempGroup._id != CurrentGroup[CurrentGroup.length - 1]._id,
            isHidden: tempStep.parentGroup != CurrentGroup[CurrentGroup.length - 1]._id && tempGroup._id != CurrentGroup[CurrentGroup.length - 1]._id ? true : false
          }




        });

        return {
          ...s,
          condition
        }

      }
        
    })
  }, [AllStep, AllGroup, CurrentGroup]);

  const Entry = useMemo(() => {

    let group = AllGroup.find(g => g._id == CurrentGroup[CurrentGroup.length - 1]._id);

    if (!group) return [];

    return group.entry.map(e => {

      let tempStep = AllStep.find(s => s._id == e.processStep);

      let condition = tempStep.condition.map(c =>
      {



        let condTempStep = AllStep.find(pStep => pStep._id == c.processStep);

        let tempGroup = AllGroup.find(g => g._id == condTempStep.parentGroup);

        return {
          ...c,
          position: condTempStep.position,
          parentGroup: tempGroup,
          useGroupPosition: tempGroup && tempGroup._id != group._id,
          isHidden: tempGroup ? false : true
        }




      });

  

      return {
        ...tempStep,
        condition,
        position: e.position,
        basePosition: tempStep.position,
        entry: e,
        group: group
      }

    });

    //return props.Step.filter(s => group.entry.findIndex(g => g.processStep == s._id) > -1);


  }, [AllStep, AllGroup, CurrentGroup]);
  const OnClickDetail = props.OnClickDetail;
  const OnClickAdd = props.OnClickAdd;
  const OnClickCondition = props.OnClickCondition;
  const OnUpdateStep = props.OnUpdateStep;
  const CopyMode = props.CopyMode;
  const CopyData = props.CopyData;
  const OnClickSelectCopy = props.OnClickSelectCopy;
  const NewCounter = props.NewCounter;
  const OnRightClickContextStep = props.OnRightClickContextStep;
  const OnRightClickContextCondition = props.OnRightClickContextCondition;
  const ParentContainer = props.ParentContainer;
  const OnUpdateGroup = props.OnUpdateGroup;
  const OnOpenGroup = props.OnOpenGroup;
  
  //State
  const [currentMoving, setCurrentMoving] = useState(undefined);
  const [currentLinking, setCurrentLinking] = useState({
    enabled: false,
    data: undefined
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //useRef
  const svgRef = useRef(null);
  const linkLineRef = useRef(null);

  useEffect(() => {

    if (!linkLineRef.current) return;

    if (currentLinking.enabled){
      linkLineRef.current.setAttribute("x1", 0);
      linkLineRef.current.setAttribute("y1", 0);
      linkLineRef.current.setAttribute("x2", 0) //+ ParentContainer.current.scrollLeft);
      linkLineRef.current.setAttribute("y2", 0) //+ ParentContainer.current.scrollTop);
    }
  }, [currentLinking.enabled]);

  const drawLine = (_step) =>
  {

    let listDraw = [];



    if (_step._id == currentMoving) return null;

    let mergeConditionGroup = []

    _step.condition.forEach(c => {


      if (_step.entry && ((!c.parentGroup) || (CurrentGroup[CurrentGroup.length - 1]._id != c.parentGroup._id))) return;

      if (c.isHidden) return;

      mergeConditionGroup.push(
        {
          parentGroup: c.parentGroup,
          position: c.useGroupPosition ? c.parentGroup.position : c.position,
          _id: _step._id,
          processStep: c.processStep,
          useGroupPosition: c.useGroupPosition
        }
      );

    });



    Group.forEach(g => {

      if (g.entry.findIndex(s => s.processStep == _step._id) > -1 && mergeConditionGroup.findIndex(m => m.parentGroup && m.parentGroup._id == g._id) == -1){


        mergeConditionGroup.push({
          parentGroup: g.parentGroup,
          position: g.position,//g.parentGroup ? g.parentGroup.position : g.position,
          _id: _step._id,
          processStep: "GROUP" + g._id
        });

      }

    });



    mergeConditionGroup.forEach(c => {


      let currentPosition = c.position;//c.parentGroup ? c.parentGroup.position : c.position;

      let x1 = currentPosition.x + (c.parentGroup ? 90 : 80);
      let y1 = currentPosition.y + 50;
      let x2 = _step.position.x + 80;
      let y2 = _step.position.y + 50;


      const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));

      const numberofArrows = Math.floor(distance / 40);


      const stepSizeX = (x2 - x1) / numberofArrows;
      const stepSizeY = (y2 - y1) / numberofArrows;
      

      for (let i = 0; i <= numberofArrows; i++)
      {
        const arrowX = x1 + i * stepSizeX;
        const arrowY = y1 + i * stepSizeY;
        const arrowX2 = x1 + (i + 1) * stepSizeX;
        const arrowY2 = y1 + (i + 1) * stepSizeY;

        listDraw.push(
          <line
            id={`${_step._id}_R_${c.processStep}_arrow_${i}`}
            key={`${_step._id}_R_${c.processStep}_arrow_${i}`}
            x1={arrowX2}  // Adjust these values based on the desired arrow size
            y1={arrowY2}
            x2={arrowX}
            y2={arrowY}
            markerEnd="url(#arrowhead)"
            stroke="black"
            className="page_noselect processdesigner_flowchart_line"
            style={{ cursor: 'pointer', pointerEvents: 'auto' }}
          />
        );

      }
  
    });




    return listDraw;

  };


  const drawCondition = (_step) =>
  {


    if (_step._id == currentMoving) return null;


    let contData = [];


    _step.condition.forEach((c, indexC) => {


      if (c.isHidden) return;

      if (c.useGroupPosition) return;

      let currentPosition = c.useGroupPosition ? c.parentGroup.position : c.position;

      let x = currentPosition.x + ((_step.position.x - currentPosition.x) / 2) + 40;
      let y = currentPosition.y + ((_step.position.y - currentPosition.y) / 2) + 35;
      
      contData.push(
        <div 
        id={_step._id + "_Condition_" + c.processStep}
        key={_step._id + "_Condition_" + c.processStep}
        className="processdesigner_flow_conditon page_noselect"
        style={{ top: y, left: x, backgroundColor: c.data.length > 0 ? "#cce5ff" : "white"}}
        title={getLabel("ConditionDesigner", "Condition(s)")} 
          onContextMenu={(e) => OnRightClickContextCondition(e, _step._id, c.processStep)}
        onClick={() => OnClickCondition(_step._id, c.processStep)}
      >
        {_step.condition.length > 1 &&
            <div className="process_condition_order_icon_cont" title={getLabel("ConditionDesigner", "Condition order") + " : " + (indexC + 1)} >
            <div className="process_condition_order_icon">
              {indexC + 1}
            </div>  
          </div>
        }
        {c.data.length <= 0 &&
          <div className="processdesigner_flow_conditon_text">
            -
          </div>
        }
        {c.data.length > 0 && c.data.length < 2 &&
          <div className="processdesigner_flow_conditon_text">
              {getConditionText(c.data[0])}
          </div>
        }
        {c.data.length > 1 &&
          <div className="processdesigner_flow_conditon_text">
            [...]
          </div>
        }     
    </div>);

    });

    return contData;

  };


  const getConditionText = (_condition) => {

    let contData = []

    if (_condition.length <= 1){

      let c = _condition[0];
      let index = 0;

      if (c.type == "if")
      {
        if (c.valueRight.type == "literal")
        {
          contData.push(
            <div className="processdesigner_flow_conditon_text" key={index}>
              {c.valueRight.data.length > 8 ? c.valueRight.data.substring(0, 6) + "...": c.valueRight.data}
            </div>
          )
        } else
        {
          contData.push(
            <div className="processdesigner_flow_conditon_text" key={index}>
              ...
            </div>
          )
        }
      } else
      {
        contData.push(
          <div className="processdesigner_flow_conditon_text" key={index}>
            ...
          </div>
        )
      }    
    }else{
      contData.push(
        <div className="processdesigner_flow_conditon_text" key={0}>
          ...
        </div>
      )
    }

    



    return contData;
  };

  const onStartLink = (e, _step) => {


    setCurrentLinking(currentLinking => ({
      enabled: !currentLinking.enabled,
      data: currentLinking.enabled ? undefined : _step,
      position: currentLinking.enabled ? undefined : { x: _step.position.x + ParentContainer.current.scrollLeft + 80, y: _step.position.y + ParentContainer.current.scrollTop + 140 }
    }));
  };


  const handleMouseMove = (e) => {


    const svg = svgRef.current;
    const line = linkLineRef.current;



    // const mouseX = e.clientX - svg.getBoundingClientRect().left;
    // const mouseY = e.clientY - svg.getBoundingClientRect().top;

    line.setAttribute("x1", currentLinking.data.position.x + 80);
    line.setAttribute("y1", currentLinking.data.position.y + 50);
    line.setAttribute("x2", e.clientX - svg.getBoundingClientRect().left) //+ ParentContainer.current.scrollLeft);
    line.setAttribute("y2", e.screenY - svg.getBoundingClientRect().top - 120) //+ ParentContainer.current.scrollTop);

  }


  const handleMouseClick = (e) => {


    if (currentLinking.enabled){
      setCurrentLinking({
        enabled: false,
        data: undefined,
        position: undefined
      });
    }

  };

  const createCondition = (_fromStep, _toStep) => {

    //If steps are already linked
    if (_toStep.condition.findIndex(c => c.processStep == _fromStep._id) > -1){


      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("ProcessDesigner", "Those two steps are already linked together."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;
    }

    let toUpdateStep = _.cloneDeep(_fromStep);

    let currentOrder = 10;

    toUpdateStep.condition.forEach(c => {
      if (c.order >= currentOrder) currentOrder = c.order + 10;
    });

    if (toUpdateStep.basePosition) toUpdateStep.position = toUpdateStep.basePosition;

    toUpdateStep.condition.push({
      processStep: _toStep._id,
      data: [],
      order: currentOrder
    });

    setCurrentLinking({
      enabled: false,
      data: undefined,
      position: undefined
    });

    OnUpdateStep(toUpdateStep);

  }

  const linkStepToGroup = (_fromStep, _toGroup) => {

    //If steps are already linked
    if (_toGroup.entry.findIndex(c => c.processStep == _fromStep._id) > -1)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("ProcessDesigner", "Those two steps are already linked together."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;
    } 

    let toUpdateGroup = _.cloneDeep(_toGroup);

    if (toUpdateGroup.entry.findIndex(s => s.processStep == _fromStep._id) == -1)
    {

      let sameGroupStep = Step.filter(s => s._id != _fromStep._id && s.parentGroup == toUpdateGroup._id);
      let sameGroupGroup = Group.filter(g => g.parentGroup == toUpdateGroup._id);


      let newPosition = FindOpenPosition(10, 50, sameGroupStep, sameGroupGroup, toUpdateGroup.entry);

      toUpdateGroup.entry.push({
        processStep: _fromStep._id,
        position: newPosition
      });

    }

    setCurrentLinking({
      enabled: false,
      data: undefined,
      position: undefined
    });

    OnUpdateGroup(toUpdateGroup);

  };


  if (!Data || !Step || (Step.length == 0 && Group.length == 0 && Entry.length == 0)) return (
    <div className="processdesigner_flowchart_info">
      {getLabel("ProcessDesigner", "To create a new step, either...")}
    </div>
  );



  return (
    <div className="processdesigner_flow_cont" 
      onMouseMove={!ReadOnly && !CopyMode && currentLinking.enabled ? handleMouseMove: undefined}
      onClick={!ReadOnly && !CopyMode && currentLinking.enabled ? handleMouseClick : undefined}
    >
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <svg width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }} ref={svgRef}>
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="10"
            refX="0"
            refY="3"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0,0 0,6 9,3" fill="black" />
          </marker>
        </defs>
        {Step.map((s, index) => (
          drawLine(s)
        ))} 
        {Entry.map((s, index) => (
          drawLine(s)
        ))}
        <line
          ref={linkLineRef}
          id={`Linking_Line`}
          key={`Linking_Line`}
          x1={0}  
          y1={0}
          x2={0}
          y2={0}
          markerEnd="url(#arrowhead)"
          stroke="black"
          className="page_noselect processdesigner_flowchart_line"
          style={{ display: currentLinking.enabled ? "block" : "none" }}
        />
      </svg>
      {Entry.map((e, index) => (
        <ProcessDesignerFlowChartEntry
          ReadOnly={ReadOnly}
          Step={AllStep}
          Data={e}
          key={"ENTRY" + e._id + "CURRENT" + CurrentGroup[CurrentGroup.length - 1]._id}
          OnUpdateStep={OnUpdateStep}
          OnClickAdd={OnClickAdd}
          OnClickDetail={OnClickDetail}
          SetCurrentMoving={setCurrentMoving}
          CopyMode={CopyMode}
          CopyData={CopyData}
          OnClickSelectCopy={OnClickSelectCopy}
          NewCounter={NewCounter}
          OnRightClickContextStep={OnRightClickContextStep}
          OnStartLink={onStartLink}
          CurrentLinking={currentLinking}
          CreateCondition={createCondition}
          OnUpdateGroup={OnUpdateGroup}
        />
      ))}
      {Group.map((g, index) => (
        <ProcessDesignerFlowChartGroup
          ReadOnly={ReadOnly}
          Step={AllStep}
          Data={g}
          key={"GROUP" + g._id + "CURRENT" + CurrentGroup[CurrentGroup.length - 1]._id}
          OnUpdateGroup={OnUpdateGroup}
          OnClickAdd={OnClickAdd}
          OnClickDetail={OnClickDetail}
          SetCurrentMoving={setCurrentMoving}
          CopyMode={CopyMode}
          CopyData={CopyData}
          OnClickSelectCopy={OnClickSelectCopy}
          NewCounter={NewCounter}
          OnRightClickContextStep={OnRightClickContextStep}
          OnStartLink={onStartLink}
          CurrentLinking={currentLinking}
          LinkStepToGroup={linkStepToGroup}
          OnOpenGroup={OnOpenGroup}
        />
      ))} 
      {Step.map((s, index) => (
        <ProcessDesignerFlowChartItem
          ReadOnly={ReadOnly}
          Step={AllStep}
          Group={AllGroup}
          Data={s}
          key={"STEP" + s._id + "CURRENT" + CurrentGroup[CurrentGroup.length - 1]._id}
          OnUpdateStep={OnUpdateStep}
          OnClickAdd={OnClickAdd}
          OnClickDetail={OnClickDetail}
          SetCurrentMoving={setCurrentMoving}
          CopyMode={CopyMode}
          CopyData={CopyData}
          OnClickSelectCopy={OnClickSelectCopy}
          NewCounter={NewCounter}
          OnRightClickContextStep={OnRightClickContextStep}
          OnStartLink={onStartLink}
          CurrentLinking={currentLinking}
          CreateCondition={createCondition}
        />
      ))}  
      {Step.map((s, index) => (
        drawCondition(s)
      ))} 
      {Entry.map((s, index) => (
        drawCondition(s)
      ))}

    </div>
  );

}

export default ProcessDesignerFlowchart;